export const getStyle = (_, { palette = {} }) => ({
  searchPromptText: {
    marginBottom: 5,
    display: 'flex',
  },
  searchAppContextualMenu: {
    width: 467,
    maxHeight: 300,
    '& button': {
      background: 'transparent',
      border: 'none',
      padding: 0,
      textAlign: 'left',
    },
    '& .matched-app-header': {
      display: 'flex',
      padding: '10px 20px',
      color: palette.neutralPrimary,
      '& .ms-StackItem': {
        flex: 1,
        fontWeight: 'bold',
        '&.app-no-col': {
          textAlign: 'right',
          flex: 'none',
        },
      },
    },
    '& .matched-app-item': {
      display: 'flex',
      padding: '10px 20px',
      color: palette.neutralPrimary,
      borderBottom: '1px solid #E1E1E1',
      cursor: 'pointer',
      '&:hover': {
        background: palette.neutralLighter,
      },
      '& .app-id-logo': {
        width: 60,
        maxWidth: 60,
        '& img': {
          width: 40,
          height: 40,
          borderRadius: 8,
        },
      },
      '& .ms-StackItem': {
        flex: 1,
        paddingRight: 10,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&.app-no-col': {
          width: 90,
          textAlign: 'right',
          flex: 'none',
        },
        '& .app-id-apptitle': {
          fontWeight: 600,
        },
      },
    },
  },
  searchAppLoading: {
    width: 167,
    height: 100,
  },
  searchHint: {
    marginTop: 4,
    height: 16,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    color: '#605E5C',
  },
  searchHintWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectedStoreApp: {
    backgroundColor: '#F3F2F1',
    padding: 16,
    display: 'flex',
    flexFlow: 'row',
    borderRadius: 3,
    '& .ms-StackItem': {
      flex: 1,
    },
    '& .ms-Image': {
      maxWidth: 68,
      '& img': {
        width: 68,
        height: 68,
        borderRadius: 8,
      },
    },
    '& .close-button': {
      maxWidth: 32,
      '& span': {
        fontSize: 14,
      },
    },
    '& .text-wrapper': {
      marginLeft: 16,
    },
  },
  textEntry: {
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    display: '-webkit-box',
    paddingRight: 20,
    maxWidth: 402,
  },
});
